<template>
  <v-container>
    <div class="display-1 mb-4">Meet Our Team</div>
    <v-row>
      <v-col cols="12" sm="6" md="4" v-for="(m, i) in members" :key="i">
        <div class="team d-flex flex-column justify-end">
          <svg class="shape" viewBox="0 0 1440 320">
            <path fill="#1976d2" fill-opacity="1" d="M0,288L48,266.7C96,245,192,203,288,154.7C384,107,480,53,576,53.3C672,53,768,107,864,138.7C960,171,1056,181,1152,170.7C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
          <div>
            <div class="avatar">
              <v-avatar size="100" style="box-shadow: 0 7px 10px 0 rgba(0, 0, 0, .4);">
                <img :src="m.image" :alt="m.name">
              </v-avatar>  
            </div>
            <div class="pt-16 team-title">
              <div>{{ m.name }} | <span class="caption">{{ m.position }}</span></div>
            </div>
            <div class="desc pa-4 text-justify pc">{{ m.description }}</div> 
            <div class="actions d-flex pa-4 pt-2">
              <v-spacer />
              <v-btn icon v-for="(social, s) in m.socials" :key="s" color="white" target="_blank" :href="social.link">
                <v-icon size="20">{{ social.icon }}</v-icon>  
              </v-btn> 
            </div>
          </div>
        </div>
      </v-col>  
    </v-row>
  </v-container>  
</template>

<script>
import { db } from '@/firebase'
export default {
  data: () => ({
    socials: [
      { title: 'Facebook', icon: 'mdi-facebook', href: 'https://www.facebook.com' }  ,
      { title: 'Linkedin', icon: 'mdi-linkedin', href: 'https://www.linkedin.com' }  ,
      { title: 'Twitter', icon: 'mdi-twitter', href: 'https://www.twitter.com' }  ,
      { title: 'Instagram', icon: 'mdi-instagram', href: 'https://www.instagram.com' }  
    ],
    members: [] 
  }),
  methods: {
    async get() {
      this.$store.commit('SET_OVERLAY', true)
      await this.$binding("members", db.collection('members').orderBy('createdAt', 'desc'))
      this.$store.commit('SET_OVERLAY', false)
    }
  },
  created() {
    this.get()
  }
}
</script>

<style scoped>
.team {
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, .4);  
  border-top-left-radius: 35px;
  position: relative;
  min-height: 30vh;
  margin-top: 50px;
}
/* shape */
.shape {
  position: absolute;
  bottom: 0;
}

.avatar {
  position: absolute; 
  top: -50px;
  width: 100%;
  display: flex;
  justify-content: center; 
}
.team-title {
  margin-top: 10px; 
  text-align: center; 
}
.team-title div {
  font-size: 22px;
  font-weight: 500;  
  line-height: 1;
}
.desc { height: 140px; }
</style>
